import { environment } from '../../../environments/environment';

export const applicationRemotes = {
  mfs: environment.remotes['mfs'],
  'id-repository': environment.remotes['id-repository'],
  mft: environment.remotes['mft'],
  'message-monitoring': environment.remotes['message-monitoring'],
};
